import { RootState } from '../../store'

export const currentNotificationListener = (state: RootState) => {
  return state.notification.listener
}
